/**
 * How often a Gesprekken screen refetches while an invitation is still waiting on the
 * queue — its gesprekken being planned, or its cascade deleting them. Resolving a
 * selection takes seconds, so a shorter tick than the bulk-PDF overview's ten.
 */
export const CONVERSATION_QUEUE_POLL_INTERVAL = 5_000;
